<section *ngIf="isSuperUser && organizationId" class="onboarding-card">
    <div class="onboarding-header">
        <h2>Organization Onboarding</h2>
        <p *ngIf="checklist" class="onboarding-status">
            Status: {{ statusIcon }} {{ statusLabel }}
        </p>
    </div>

    <div *ngIf="loading" class="onboarding-loading">Loading onboarding status...</div>
    <div *ngIf="loadError && !loading" class="onboarding-error">Unable to load onboarding checklist.</div>

    <ng-container *ngIf="checklist && !loading">
        <div class="onboarding-summary">
            <span>{{ checklist.completed_steps }} of {{ checklist.total_steps }} Completed</span>
            <span class="onboarding-percentage">{{ checklist.completion_percentage }}%</span>
        </div>

        <div
                class="onboarding-progress"
                role="progressbar"
                [attr.aria-valuenow]="checklist.completion_percentage"
                aria-valuemin="0"
                aria-valuemax="100">
            <div class="onboarding-progress-fill" [style.width.%]="checklist.completion_percentage"></div>
        </div>

        <ul class="onboarding-items">
            <li *ngFor="let item of checklist.items" [class.completed]="item.completed"
                [class.pending]="!item.completed">
                <span class="item-icon">{{ getItemIcon(item.completed) }}</span>
                <span class="item-title">{{ item.title }}</span>
            </li>
        </ul>
    </ng-container>
</section>
